export default __webpack_public_path__ + "static/media/project_card_thumbnail.113014ba.svg";